import React from "react";

function SearchIcon() {
  return (
    <span className="anticon anticon-search">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 16 16"
      >
        <path
          fill="currentColor"
          fillRule="nonzero"
          d="M13.55 11.854c-.236-.236-.875-.47-1.918-.702a6.618 6.618 0 001.73-4.471C13.362 2.998 10.364 0 6.681 0S0 2.998 0 6.68c0 3.684 2.998 6.682 6.68 6.682 1.714 0 3.29-.651 4.472-1.73.217 1.016.451 1.656.702 1.918l2.09 2.09c.24.24.549.36.857.36a1.21 1.21 0 00.856-2.056l-2.107-2.09zm-6.87.137a5.315 5.315 0 01-5.31-5.31c0-2.93 2.382-5.31 5.31-5.31 2.93 0 5.311 2.38 5.311 5.31 0 2.93-2.38 5.31-5.31 5.31z"
        ></path>
      </svg>
    </span>
  );
}

export default SearchIcon;
